"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Prices;

var _react = _interopRequireWildcard(require("react"));

var _PaymentSummarySpan = _interopRequireDefault(require("./PaymentSummarySpan"));

function Prices(_ref) {
  var discount = _ref.discount,
      basePrice = _ref.basePrice,
      grandTotal = _ref.grandTotal,
      currency = _ref.currency;
  var isDiscount = Number(discount) > 0;
  return _react["default"].createElement("div", {
    className: "service-list price"
  }, _react["default"].createElement("ul", null, isDiscount && _react["default"].createElement(_react.Fragment, null, _react["default"].createElement(_PaymentSummarySpan["default"], {
    title: "SubTotal",
    value: "".concat(currency, " ").concat(Number(basePrice).toLocaleString())
  }), _react["default"].createElement(_PaymentSummarySpan["default"], {
    title: "Discount",
    value: "".concat(currency, " ").concat(Number(discount).toLocaleString())
  })), _react["default"].createElement(_PaymentSummarySpan["default"], {
    title: "Grand Total",
    value: "".concat(currency, " ").concat(Number(grandTotal).toLocaleString()),
    isHighlighted: true
  })));
}